import { getEnvironment } from '../utils/envHelpers'

const env = getEnvironment()

const currentUserKey = `sp-current-user-${env}`
const lastUserStoreKey = `sp-last-user-${env}`

class LocalUserService {
  getLastUser() {
    let lastUser = localStorage.getItem(lastUserStoreKey)
    if (!lastUser) {
      return null
    }
    return JSON.parse(lastUser)
  }

  storeLastUser(user) {
    localStorage.setItem(lastUserStoreKey, JSON.stringify(user))
  }

  updateSessionInfo(sessionId, userToken, extra) {
    const prevData = JSON.parse(localStorage.getItem(currentUserKey)) || {}

    const data = {
      ...prevData,
      sessionId,
      userToken,
      merchantId: prevData.merchantId,
      user: prevData.user
    }

    if (extra && typeof extra === 'object') {
      if (extra.userId != null) {
        data.userId = extra.userId
      }
      if (extra.dashboardUserId != null) {
        data.dashboardUserId = extra.dashboardUserId
      }
    }

    localStorage.setItem(currentUserKey, JSON.stringify(data))
  }

  setCurrentUserInfo(loginInfo) {
    const data = {
      sessionId: loginInfo.sessionId,
      merchantId: loginInfo.merchantId,
      userToken: loginInfo.userToken,
      userId: loginInfo.userId,
      user: loginInfo.user
    }

    localStorage.setItem(currentUserKey, JSON.stringify(data))
  }

  getCurrentUserInfo() {
    return JSON.parse(localStorage.getItem(currentUserKey))
  }

  removeCurrentUser() {
    localStorage.removeItem(currentUserKey)
  }
}

export default LocalUserService
